import {getProductCustomFieldsAndRefreshRender} from "@plugins-fr/CustomFields";

/**
 * 商品自訂欄位表單
 * @param {array} forms
 */
$(function(){
    if (isReservable == 1) {
        getProductCustomFieldsAndRefreshRender({
            url: productCustomFieldsUrl,
            isMobile: typeof is_mobile !== 'undefined' && is_mobile === 1
        });
    }
});
